(function () {
  const isiOS = /iP(ad|hone|od)/.test(navigator.platform) ||
                (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  if (!isiOS) return;

  // 👉 Reihenfolge: Theme-Wrapper, MainContent, Fallback auf Document
  const selectors = [
    '.site-wrapper',
    '.scroll-wrapper',
    '#MainContent',
    '.content-for-layout',
    'body',
    'html'
  ];

  let scroller = null;
  for (const sel of selectors) {
    const el = document.querySelector(sel);
    if (el && el.scrollHeight > el.clientHeight + 20) {
      scroller = el;
      break;
    }
  }

  if (!scroller) scroller = document.scrollingElement || document.documentElement;

  scroller.style.overscrollBehavior = 'none';
  scroller.style.overscrollBehaviorY = 'none';
  scroller.style.overscrollBehaviorX = 'none';

  let startY = 0;
  let touching = false;

  scroller.addEventListener('touchstart', e => {
    touching = true;
    startY = e.touches[0].clientY;
  }, { passive: true });

  scroller.addEventListener('touchend', () => touching = false, { passive: true });

  scroller.addEventListener('touchmove', e => {
    if (!touching) return;
    const goingUp = e.touches[0].clientY > startY;
    const goingDown = e.touches[0].clientY < startY;
    const top = scroller.scrollTop;
    const max = scroller.scrollHeight - scroller.clientHeight;
    if ((top <= 0 && goingUp) || (top >= max && goingDown)) {
      e.preventDefault();
    }
  }, { passive: false });
})();
